import { FC } from 'react'
import { GetServerSideProps } from 'next'
import dynamic from 'next/dynamic'
import { LayoutHeader } from '@/components/domains/layouts'
import SeoHeader from '@/components/domains/layouts/header/SeoHeader'
import ROUTES from '@/constants/legacy/constRoutes'
import { EventContainer, EventContainerProps } from '@/containers/contexts/regional/event.container'
import { EventByAdSlugDocument } from '@/graphql/generated/hooks'
import { EventByAdSlugQuery, EventByAdSlugQueryVariables } from '@/graphql/generated/operations'
import { addApolloState, initializeApollo } from '@/utils/utilApolloClient'
import { getSeoKeywordByPetType } from '@/utils/utilSeo'

/**
 * 서버사이드 랜더링시에 description의 html을 파싱하면서 html 구조에 문제가 생기는 이슈가 있어, ssr을 false로 설정
 */
const HomeEventDetailContentV4 = dynamic(() => import('@/components/domains/home/HomeEventDetailContentV4'), {
  ssr: false,
})

const PageHomeEventDetail: FC<EventContainerProps> = ({ ad }) => {
  const { slug, name } = ad
  const { petType } = getSeoKeywordByPetType(ad.petType)

  return (
    <>
      <SeoHeader
        title={`${name} | ${petType} - 핏펫몰`}
        metaDescription={`오직 핏펫에서만 만나볼 수 있는 ${petType}를 위한 특별한 ${name}의 다양한 이벤트 혜택! 하나도 놓치지 말고 꼭 참여하세요!`}
        pathname={ROUTES.HOME.EVENTS.DETAIL.replace('[adSlug]', slug || '')}
      />
      <EventContainer.Provider initialState={{ ad }}>
        <LayoutHeader />
        <HomeEventDetailContentV4 key={slug} />
      </EventContainer.Provider>
    </>
  )
}

export default PageHomeEventDetail

export const getServerSideProps: GetServerSideProps = async (context) => {
  const apolloClient = initializeApollo()

  const adSlug = context?.query?.adSlug || ''
  if (!adSlug) {
    return {
      notFound: true,
    }
  }

  const { data } = await apolloClient.query<EventByAdSlugQuery, EventByAdSlugQueryVariables>({
    query: EventByAdSlugDocument,
    variables: {
      slug: String(adSlug),
      filter: {
        orderBy: 'isRealSoldOut,displayOrder',
        isShown: true,
        isRange: true,
        isProductRange: true,
      },
    },
  })

  if (!data?.adBySlug) {
    return {
      notFound: true,
    }
  }

  return addApolloState(apolloClient, {
    props: {
      ad: data.adBySlug,
    },
  })
}
